import GlobalComponents from './globalComponents';

import 'src/assets/sass/black-dashboard-pro.scss';

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
  },
};
